import {
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_BEGIN,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_SUCCESS,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectCustomJs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/content-js`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectCustomJsError() {
  return {
    type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_BEGIN:
      return {
        ...state,
        addProjectCustomJsPending: true,
        addProjectCustomJsError: null,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_SUCCESS:
      return {
        ...state,
        addProjectCustomJsPending: false,
        addProjectCustomJsError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE:
      return {
        ...state,
        addProjectCustomJsPending: false,
        addProjectCustomJsError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_DISMISS_ERROR:
      return {
        ...state,
        addProjectCustomJsError: null,
      };

    default:
      return state;
  }
}
